export const EMPLOYEE_DATA = "EMPLOYEE_DATA";
export const MEMBER_OR_LEADER_GRID = "MEMBER_OR_LEADER_GRID";
export const APPROVER_DATA = "APPROVER_DATA";
export const REQUEST_TYPE = "REQUEST_TYPE";
export const SESSION_EXPIRED = "SESSION_EXPIRED";
export const GET_USER_DETAILS = "GET_USER_DETAILS";
export const GET_BUSINESSRULES_FLEXIBILITY = "GET_BUSINESSRULES_FLEXIBILITY";
export const GET_CREATE_FLEXIBILITY_DATA = "GET_CREATE_FLEXIBILITY_DATA";
export const IS_VALID_APPROVER = "IS_VALID_APPROVER";
export const SET_PROGRESS_BAR = "SET_PROGRESS_BAR";
export const SET_HOLIDAYS_OR_SEASONS = "SET_HOLIDAYS_OR_SEASONS";
export const FILE_UPLOAD_PAGE = "FILE_UPLOAD_PAGE";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const IS_VALID_TOKEN = "IS_VALID_TOKEN";
export const BULK_SUBMIT_WFH = "BULK_SUBMIT_WFH";
export const USER_SEARCH_LIST = "USER_SEARCH_LIST";
export const SEASONS_STATUS_LIST = "SEASONS_STATUS_LIST";
export const SET_SUPER_ADMIN_FLAG = "SET_SUPER_ADMIN_FLAG";
export const GET_USER_IMAGE = "GET_USER_IMAGE";
export const GET_NOTIFICATION_MESSAGE = "GET_NOTIFICATION_MESSAGE";
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";
